/**
 * Created by jv on 26/01/2017.
 */
const utils = require("Sources/utils/utils");
const Article = require("Sources/models/store/article");

module.exports = class CartItem
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.comment = options["comment"];
    this.priceNoVat = options["price-without-vat"];
    this.priceVat = options["price-with-vat"];
    this.quantity = options.count;

    this.article = options["catalog-article"];
  };

  set article(article)
  {
    this._article = null;

    if(utils.isNotNull(article))
    {
      this._article = new Article(article);
    }
  };

  get article()
  {
    return this._article;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/store/cart-item.js